import axios from 'axios';

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api';

export const saveVote = async (topic, vote, previousVote = null) => {
    try {
        const response = await axios.post(`${BACKEND_API_URL}/vote`, {
            topic,
            vote,
            previousVote
        });
        return response.data;
    } catch (error) {
        console.error('Error saving vote:', error);
        throw error;
    }
};

export const getVoteHistory = async (topic = null) => {
    try {
        const url = topic ? 
            `${BACKEND_API_URL}/vote-history?topic=${encodeURIComponent(topic)}` : 
            `${BACKEND_API_URL}/vote-history`;
            
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching vote history:', error);
        throw error;
    }
};